import React from 'react';
import usePageTracking from './usePageTracking';

const TrackingWrapper = ({ children }: { children: React.ReactNode }) => {
  usePageTracking();

  return <>{children}</>;
};

export default TrackingWrapper;
